import {createContext} from 'react';

export const SetVisibilityContext = createContext<{close: () => void}>(null!);
